import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../components/Index.vue'
import Master from '../views/Master.vue'
//import LoginMaster from '../views/LoginMaster.vue'
//import login from '../login.vue'
//import { store } from '../store/store'
//import tfa from '../components/2fa.vue'
import search from '../components/Search.vue'
import links from '../components/Links.vue'
//import addtfa from '../components/addtfa.vue'
//import changepass from '../components/changepass.vue'
import CallBack from '../views/LoginCallBack.vue'
import CheckProfile from '../views/CheckProfile'
import SoiList from '../components/uploadSOI.vue'
import DownloadStats from "../components/DownloadStats.vue"
import UserDownloads from "../components/ViewUserDownloadLogs.vue"
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Master,
        children: [
            {
                path: '/Dash',
                name: 'Dash',
                component: Index
            },
            {
                path: '/Search',
                name: 'Search',
                component: search
            },
            {
                path: '/Links/:id/:description',
                name: 'Links',
                component: links
            },
            {
                path: 'SoiList',
                name: 'SoiList',
                component: SoiList
            },
            {
                path: '/DownloadStats',
                name: 'DownloadStats',
                component: DownloadStats
            },
            {
                path: 'Downloads',
                name: 'Downloads',
                component: UserDownloads
            }
        ]
    },
    //{
    //    path: '/',
    //    component: LoginMaster,
    //    children: [
    //        //{
    //        //    path: '/login',
    //        //    name: 'Login',
    //        //    component: login
    //        //},
    //        {
    //            path: '/tfa',
    //            name: 'tfa',
    //            component: tfa
    //        },
    //        {
    //            path: '/addtfa',
    //            name: 'addtfa',
    //            component: addtfa
    //        },
    //        {
    //            path: '/changepass',
    //            name: 'changepass',
    //            component: changepass
    //        }
    //    ]
    //},
    //{
    //    path: '',
    //    component: login
       
    //},
    {
        path: '/callback',
        name: 'callback',
        component: CallBack
    },
    {
        path: '/checkprofile',
        name: 'checkprofile',
        component: CheckProfile
    },
    //{
    //    path: '/:catchAll(.*)',
    //    name : 'login',
    //    component: login
    //}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//router.beforeEach((to, from, next) => {
//    // redirect to login page if not logged in and trying to access a restricted page
//    const publicPages = ['/login', '/calback'];
//    const authRequired = !publicPages.includes(to.path);
//    const loggedIn = store.getters.token;
//    if (authRequired && !loggedIn) {
//        return next('/login');
//    }

//    next();
//})
export default router
